"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

var DEFAULTS = {
  fetchStatus: _constants.RequestStatus.UNINITIALIZED,
  objects: new _immutable.List(),
  lastFetchOffset: 0
};

var Revisions = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Revisions, _Record);

  function Revisions() {
    (0, _classCallCheck2.default)(this, Revisions);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Revisions).apply(this, arguments));
  }

  (0, _createClass2.default)(Revisions, [{
    key: "updateOnFetchSuccess",
    value: function updateOnFetchSuccess(data) {
      var objects = data.objects,
          newFetchOffset = data.offset;
      var updatedObjects = objects; // if we're re-fetching the first page, we want to blow away existing state,
      // since it could be stale; otherwise add to existing state

      var isFreshFetch = newFetchOffset === 0;

      if (!isFreshFetch) {
        updatedObjects = this.objects.concat(objects);
      }

      return this.merge({
        fetchStatus: _constants.RequestStatus.SUCCEEDED,
        objects: new _immutable.List(updatedObjects),
        lastFetchOffset: newFetchOffset
      });
    }
  }]);
  return Revisions;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Revisions;
module.exports = exports.default;